import { Link } from 'react-router-dom';
import { EmptyState, PageHeader } from '../components/ui/misc';

export function NotFoundPage() {
  return (
    <div>
      <PageHeader title="Page not found" />
      <EmptyState
        title="There’s nothing here"
        description="The page you tried to open doesn’t exist."
        action={
          <Link to="/" className="text-sm font-medium text-primary hover:underline">
            Back to dashboard
          </Link>
        }
      />
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div>
      <PageHeader title="No access" />
      <EmptyState
        title="You don’t have permission for this area"
        description="Your role doesn’t include this module. If you think that’s wrong, ask your administrator."
        action={
          <Link to="/" className="text-sm font-medium text-primary hover:underline">
            Back to dashboard
          </Link>
        }
      />
    </div>
  );
}
